// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/styles/CategoryAreas.scss
// module id = 1349
// module chunks = 0